import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María L.', 'Carlos G.', 'Laura P.', 'Diego M.', 'Romina S.', 'Facundo R.', 'Valentina T.', 'Martín B.', 'Camila D.', 'Nicolás F.', 'Florencia A.', 'Gonzalo H.', 'Luciana V.', 'Sebastián C.', 'Paula K.', 'Agustín N.', 'Daniela E.', 'Federico J.', 'Julieta O.', 'Matías W.'];
const locations = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Formosa', 'Posadas', 'San Luis', 'Corrientes', 'Bahía Blanca', 'Paraná', 'Santiago del Estero', 'Jujuy'];
const packs = ['MegaPack Salir del Veraz', 'MegaPack + Retribución'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 45) + 3;
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    location: '',
    pack: '',
    minutes: 0
  });
  useEffect(() => {
    const showToast = () => {
      setData({
        name: getRandomItem(names),
        location: getRandomItem(locations),
        pack: getRandomItem(packs),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Show first one after 8 seconds
    const initialTimeout = setTimeout(showToast, 8000);
    // Then every 50 seconds
    const interval = setInterval(showToast, 45000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-294">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-6 left-6 z-50 max-w-xs" data-id="element-295">
          <div className="flex items-start gap-3 rounded-xl px-4 py-3 shadow-2xl border border-brand-gold/20" style={{
        background: 'linear-gradient(135deg, #141210 0%, #0c0b09 100%)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 20px rgba(201,168,76,0.08)'
      }} data-id="element-296">
            <div className="shrink-0 w-9 h-9 rounded-full bg-green-500/20 flex items-center justify-center text-lg" data-id="element-297">
              🛒
            </div>
            <div className="flex flex-col" data-id="element-298">
              <p className="text-white text-sm font-semibold leading-tight" data-id="element-299">
                {data.name}
                <span className="text-gray-400 font-normal" data-id="element-300"> de </span>
                <span className="text-brand-gold" data-id="element-301">{data.location}</span>
              </p>
              <p className="text-gray-400 text-xs mt-0.5" data-id="element-302">
                compró el{' '}
                <span className="text-green-400 font-medium" data-id="element-303">{data.pack}</span>
              </p>
              <p className="text-gray-600 text-[10px] mt-1" data-id="element-304">
                hace {data.minutes} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}